import { z } from 'zod';

export const DepositInfoResultSchema = z.object({
  data: z.array(
    z.object({
      payment_network: z.string(),
      currency: z.string(),
      bank_details: z.object({
        account_holder_name: z.string(),
        bank_name: z.string(),
        bank_address: z.string(),
        bank_country: z.string(),
        routing_number: z.number().nullable(),
        account_number: z.number().nullable(),
        recipient_name: z.string().nullable(),
        recipient_address: z.string().nullable(),
        bic_code: z.string(),
        iban_code: z.string(),
        reference_code: z.string().nullable(),
      }),
    }),
  ),
});

export type DepositInfoResult = z.infer<typeof DepositInfoResultSchema>;

export interface DepositInfoParams {
  payment_network: string | null;
}
